module.exports = "<item-value ng-if=!ctrl.isArray collection-id=ctrl.collectionId item-keys=ctrl.key>{{ctrl.output}}</item-value>";